/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginDto } from '../../models/login-dto';
import { SignInBundleDto } from '../../models/sign-in-bundle-dto';

export interface ApiAccountLoginPost$Params {
  'api-version'?: string;
      body?: LoginDto
}

export function apiAccountLoginPost(http: HttpClient, rootUrl: string, params?: ApiAccountLoginPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SignInBundleDto>> {
  const rb = new RequestBuilder(rootUrl, apiAccountLoginPost.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SignInBundleDto>;
    })
  );
}

apiAccountLoginPost.PATH = '/api/account/login';
